import { selectCurrentUser } from "./auth";
import { firebaseNormalizer } from "./global";

export const selectAllUsers = state => {
  return firebaseNormalizer(state, "users");
};
export const selectCursoByCurrentUser = state => {
  const currentUser = selectCurrentUser(state);
  const allUsers = selectAllUsers(state);

  const filteredUsers = allUsers.filter(
    user =>
      user.colegio === currentUser.colegio &&
      user.nivel === currentUser.nivel &&
      user.identificadorNivel === currentUser.identificadorNivel &&
      !user.groupKey
  );

  return filteredUsers;
};
export const selectUsersByParams = (state, values) => {
  const usersPerNivel = [];
  const { users } = state.firebase;

  users &&
    users.allIds.map(userId => {
      const user = users.byId[userId];
      if (
        user.colegio === values.colegio &&
        user.nivel === values.nivel &&
        user.identificadorNivel === values.identificadorNivel
      ) {
        usersPerNivel.push(user);
      }
    });

  return usersPerNivel;
};

export const selectUserById = (state, userId) => {
  const { users } = state.firebase;
  return users.byId[userId];
};

export const selectUsersByIds = (state, userIds) => {
  const { users } = state.firebase;
  return userIds.map(userId => {
    const user = users.byId[userId];
    return user;
  });
};
